import  { ReactNode } from "react";
// External dependencies
import classNames from "classnames";

interface CollapsedInnerContainerProps {
  className?: string;
  subClassName?: string;
  children: ReactNode;
}

const CollapsedInnerContainer = ({ className, subClassName, children }: CollapsedInnerContainerProps) => {
  // Combining default and additional classes for the card classes
  const CardClasses = classNames("collpased-details", className);

  // Combining default and additional classes for the sub-card classes
  const CardSubClasses = classNames("", subClassName);

  return (
    <div className={CardClasses} style={{ paddingLeft: "30px" }}>
      <div className={CardSubClasses}>{children}</div>
    </div>
  );
};

export default CollapsedInnerContainer;
